(() => {
  const care = document.querySelector('.pc-booking-care');
  if (!care) return;
  const params = new URLSearchParams(window.location.search);
  const requested = {arrival:params.get('arrival_time'),departure:params.get('departure_time'),destination:params.get('destination')};
  const validTime = value => /^([01]\d|2[0-3]):[0-5]\d$/.test(value || '');
  const enhance = () => {
    const widget = document.getElementById('izyrent');
    if(!widget) return;
    widget.querySelectorAll('.izyNote').forEach((row,index) => {
      const label = row.querySelector('label');
      const field = row.querySelector('.izyArea,.izySelect');
      if(!label || !field) return;
      const title = label.textContent.trim();
      field.id = field.id || 'pc-reservation-field-'+index;
      if(field.getAttribute('aria-label') !== title) field.setAttribute('aria-label',title);
      if(title.toLowerCase().includes('telefono')) {field.placeholder=care.dataset.phone;field.inputMode='tel';field.autocomplete='tel';}
      if(title.toLowerCase().includes('passeggeri')) {field.placeholder=care.dataset.pax;field.inputMode='numeric';}
      if(title.includes('Nome e Cognome')) field.autocomplete='name';
      if(!field.dataset.pcPrefilled) {
        let value=null;
        if((title.toLowerCase().includes('orario di ingresso') || title.toLowerCase().includes('orario di entrata')) && validTime(requested.arrival)) value=requested.arrival;
        if(title.toLowerCase().includes('orario di uscita') && validTime(requested.departure)) value=requested.departure;
        if(title.toLowerCase().includes('navetta per') && ['station','port'].includes(requested.destination)) value=requested.destination==='port'?'Porto di Salerno':'Stazione di Salerno';
        if(value!==null) {field.dataset.pcPrefilled='true';field.value=value;field.dispatchEvent(new Event('input',{bubbles:true}));field.dispatchEvent(new Event('change',{bubbles:true}));}
      }
      let timeSelect = row.querySelector('.pc-izy-time');
      if(title.includes('HH:MM') && !timeSelect) {
        timeSelect = document.createElement('select');
        timeSelect.className = 'pc-izy-time';
        timeSelect.id = field.id+'-choices';
        timeSelect.required = true;
        timeSelect.setAttribute('aria-label',title);
        timeSelect.append(new Option(care.dataset.chooseTime,''));
        for(let slot=0;slot<48;slot++) {
          const value=String(Math.floor(slot/2)).padStart(2,'0')+':'+(slot%2?'30':'00');
          timeSelect.append(new Option(value,value));
        }
        if(validTime(field.value) && !Array.from(timeSelect.options).some(option=>option.value===field.value)) timeSelect.append(new Option(field.value,field.value));
        timeSelect.value = validTime(field.value) ? field.value : '';
        field.hidden = true;
        field.style.display = 'none';
        field.removeAttribute('required');
        field.tabIndex=-1;
        field.insertAdjacentElement('afterend',timeSelect);
        timeSelect.addEventListener('change',()=>{
          field.value=timeSelect.value;
          field.dispatchEvent(new Event('input',{bubbles:true}));
          field.dispatchEvent(new Event('change',{bubbles:true}));
        });
      }
      const targetId = timeSelect ? timeSelect.id : field.id;
      if(label.htmlFor !== targetId) label.htmlFor=targetId;
    });
    widget.querySelectorAll('.izyAddon').forEach(row=>{const field=row.querySelector('.izyBox');const title=row.dataset.title;if(field&&title&&field.getAttribute('aria-label')!==title)field.setAttribute('aria-label',title);});
    widget.querySelectorAll('input.izyDate:not([type="hidden"])').forEach((field,index)=>{
      const label=index===0?care.dataset.arrival:care.dataset.departure;
      if(field.getAttribute('aria-label')!==label)field.setAttribute('aria-label',label);
      if(field.placeholder!==label)field.placeholder=label;
      const wrap=field.closest('.label_izyrent');
      if(wrap&&!wrap.querySelector('.pc-date-label')){const text=document.createElement('span');text.className='pc-date-label';text.textContent=label;wrap.prepend(text);}
    });
  };
  let scheduled=false;
  const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;enhance();});};
  enhance();
  const main=document.querySelector('main');
  if(main)new MutationObserver(schedule).observe(main,{childList:true,subtree:true});
})();
